import { Flex } from "antd"
import { Title } from "ui/Typography"
import { useTranslation } from "react-i18next"
import IconWithBg from "ui/IconWithBg"
import { LeftOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import { spacings } from "themes/variables"

const ClientProfileHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleBackToClients = () => {
    navigate(-1)
  }

  return (
    <Flex gap={spacings.M} className="py-3xl">
      <IconWithBg icon={<LeftOutlined />} onClick={handleBackToClients} />
      <Title level={3}>{t("client.profile.settings")}</Title>
    </Flex>
  )
}

export default ClientProfileHeader
